module.exports = __webpack_public_path__ + "static/nebula.1bf751ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/papers/nebula.png
// module id = 562
// module chunks = 35783957827783